import { render, staticRenderFns } from "./ComponentReturnShippingFee.vue?vue&type=template&id=af523b22&"
import script from "./ComponentReturnShippingFee.vue?vue&type=script&lang=ts&"
export * from "./ComponentReturnShippingFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports